import "./teamMember.css"

export function TeamMember({ image, name, role }){
    return (
        <div className="d-flex flex-column team-member">
            <img src={image} className="rounded-1" alt="" />
            <div className="member-name mt-3">{name}</div>
            <div className="member-role">{role}</div>
            <div className="member-links d-flex mt-3">
                <div className="twitter"></div>
                <div className="instagram"></div>
                <div className="linkedin"></div>
            </div>
        </div>
    )
}